import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const http = axios.create({ baseURL: API, timeout: 15000 });

/**
 * Defensive frontend filter: strip any track released after 2005. Belt-and-
 * suspenders alongside the backend filter, so if the API ever drifts (cache,
 * deploy mismatch, mocked data) no post-2005 song sneaks into the UI.
 */
const MAX_YEAR = 2005;

function yearFrom(track) {
  const d = track?.release_date;
  if (!d) return null;
  const y = parseInt(String(d).slice(0, 4), 10);
  return Number.isFinite(y) ? y : null;
}

function filterEra(tracks) {
  if (!Array.isArray(tracks)) return [];
  return tracks.filter((t) => {
    const y = yearFrom(t);
    // Drop unknown years too — we don't want to leak anything we can't verify.
    return y !== null && y <= MAX_YEAR;
  });
}

function sanitizePayload(data) {
  const tracks = filterEra(data?.tracks);
  return { ...data, count: tracks.length, tracks };
}

export const api = {
  search: async (q, limit = 25) => {
    const { data } = await http.get("/search", { params: { q, limit } });
    return sanitizePayload(data);
  },
  fresh: async (limit = 24) => {
    const { data } = await http.get("/fresh", { params: { limit } });
    return sanitizePayload(data);
  },
  genre: async (name, limit = 18) => {
    const { data } = await http.get(`/genre/${encodeURIComponent(name)}`, { params: { limit } });
    return sanitizePayload(data);
  },
  stats: async () => {
    const { data } = await http.get("/stats");
    return data;
  },
};
